import { render } from "./ChildInfoModal.vue?vue&type=template&id=2dfb7a6c&scoped=true"
import script from "./ChildInfoModal.vue?vue&type=script&lang=js"
export * from "./ChildInfoModal.vue?vue&type=script&lang=js"

import "./ChildInfoModal.vue?vue&type=style&index=0&id=2dfb7a6c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfb7a6c"]])

export default __exports__